<div class="footer-container">
    <div class="content-area">
        <div class="section">
            <img class="footer-icon" src="../../../../assets/images/dhl_footer.png">
        </div>
        <div class="section">
            <ul>
                <li style="cursor: pointer;" (click)="onLeagel('terms')">Terms of Use</li>
                <li style="cursor: pointer;" (click)="onLeagel('privacy')">Privacy Notice</li>
                <li style="cursor: pointer;" (click)="onLeagel('cookie')">Cookie Setting</li>
            </ul>
        </div>
        <div class="section section-3">
            <p class="verion-txt">Application Version: 1.0.0 - release Date: 18/03/2025 08:57</p>
            <p class="verion-txt">Last successful login: <span>{{lastLoginDate}} {{lastLoginTime}}</span></p>
            <p class="verion-txt right-align">2025 © DHL International GmbH. All rights reserved.</p>
        </div>
    </div>
    
</div>